import type { MessageItemType } from '@/types'
import type MessagePlain from '@/views/chat/components/message-plain.vue'
import { computed } from 'vue'

export function useMessageComponent(message: MessageItemType) {
  const plainAttrs = computed<InstanceType<typeof MessagePlain>['$props']>(() => {
    return {
      from: message.from,
      timestamp: message.timestamp,
      showHeader: !('message' in message) && message.showHeader,
    }
  })
  return {
    plainAttrs,
  }
}
